import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=4d432840&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=4d432840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d432840",
  null
  
)

export default component.exports